<template>
	<div class="container">
		<div class="content has-text-centered">
			<h1>Cargando...</h1>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.content {
	padding: 20px;
	min-height: 40vh;
}
</style>
